import CustomerAccount from '@screens/customer/account'

export default function CustomerAccountPage() {
  return <CustomerAccount />
}
